import React, { useEffect, useState, useRef } from 'react';
import { IoIosArrowUp } from "react-icons/io";

const ScrollProgress = () => {
  const [scrollValue, setScrollValue] = useState(0);
  const progressRef = useRef(null);

  const calcScrollValue = () => {
    const pos = document.documentElement.scrollTop;
    const calcHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const newValue = Math.round((pos * 100) / calcHeight);
    setScrollValue(newValue);
    return pos > 100 ? 'grid' : 'none';
  };

  useEffect(() => {
    const scrollListener = () => {
      const scrollProgress = progressRef.current;
      if (!scrollProgress) return;

      const displayStyle = calcScrollValue();
      scrollProgress.style.display = displayStyle;
      scrollProgress.style.background = `conic-gradient(#3d7ba7 ${scrollValue}%, #d7d7d7 ${scrollValue}%)`;
    };

    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [scrollValue]);

  const handleScrollToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  return (
    <div id="progress" ref={progressRef} style={{ display: 'none' }} onClick={handleScrollToTop}>
      <span id="progress-value"><IoIosArrowUp /></span>
    </div>
  );
};

export default ScrollProgress;
